export default function Footer() {
  return (
    <footer className="py-12 md:py-16 px-4 md:px-6 bg-secondary-100 border-t border-background-200/70">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-database-2-line text-white"></i>
              </div>
              <span className="text-base font-semibold font-heading text-foreground-950">
                Sugargoo Spreadsheet
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The #1 resource hub for Sugargoo product discovery, organized spreadsheets, QC guides, shipping comparisons, and exclusive buying tips.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2.5">
              <a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Home</a>
              <a href="/article/sugargoo-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Ultimate Guide</a>
              <a href="/article/sugargoo-buying-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Shopping Guide</a>
              <a href="/article/sugargoo-review-2026" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Sugargoo Review</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Main Website</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">SEO Guides</h4>
            <div className="flex flex-col gap-2.5">
              <a href="/article/sugargoo-shipping-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Shipping Cost Guide</a>
              <a href="/article/sugargoo-coupon-savings" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Coupon & Discounts</a>
              <a href="/article/sugargoo-safety-legit" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Safety & Trust</a>
              <a href="/article/sugargoo-warehouse-qc" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Warehouse & QC</a>
              <a href="/article/sugargoo-pro-tips" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">Pro Tips</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Popular Categories</h4>
            <div className="flex flex-col gap-2.5">
              {["Shoes", "Hoodies/Sweaters", "T-Shirts", "Jackets", "Accessories"].map((cat) => (
                <a
                  key={cat}
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {cat}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 sugargoosheet.my. All rights reserved. This is an independent resource website and is not affiliated with Sugargoo.
          </p>
          <div className="flex items-center gap-4">
            <a href="/article/sugargoo-safety-legit" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Safety</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">Main Website</a>
          </div>
        </div>
      </div>
    </footer>
  );
}